import { css } from '@emotion/css'
import { colors, spacing } from '@offerzen/pinata'

const styles = {
  jobsTitleWrapper: css({
    display: 'flex',
    alignItems: 'center',
  }),

  title: css({
    color: colors.oxfordBlue,
  }),

  betaChip: css({
    marginLeft: spacing.small,
  }),
}

export default styles
